// Safari a volte non applica in tempo l'attributo JSX "muted" prima dell'autoplay:
// va forzato come proprietà DOM al mount, altrimenti l'autoplay viene bloccato
// silenziosamente e compare il pulsante "play" manuale al posto del video.
const forceMutedAutoplay = (video) => {
  if (!video) return;
  video.muted = true;
  video.play().catch(() => {});
};

export default forceMutedAutoplay;
